import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBookmarkOutlined = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M19.5 20.4966V4.5C19.5 3.39543 18.6046 2.5 17.5 2.5H6.5C5.39543 2.5 4.5 3.39543 4.5 4.5V20.4966C4.5 21.2881 5.37596 21.7659 6.04144 21.3373L10.9171 18.1974C11.5766 17.7727 12.4234 17.7727 13.0829 18.1974L17.9586 21.3373C18.624 21.7659 19.5 21.2881 19.5 20.4966Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgBookmarkOutlined;
